import angular from 'angular';
import breadcrumb from './components/Breadcrumb/breadcrumb.js';
import returnsButton from './components/ReturnsButton/returnsButton.js';
import spinner from './components/Spinner/spinner.js';
import returnsHelpTooltip from './components/ReturnsHelpTooltip/returnsHelpTooltip.js';

angular.module('narvarReturns', [
  'ngRoute',
  'ngAnimate',
  'ngSanitize',
  'appRoutes',
  'MainCtrl',
  'Step1Ctrl',
  'Step2Step3Ctrl',
  'Step4Ctrl',
  'StepAsyncLabelCtrl',
  'PrinterlessInfoController',
  'FaqPageController',
  'PickupsPageController',
  'LoginPageController',
  breadcrumb.name,
  returnsButton.name, // Still used in step-1.html page
  spinner.name, // Still used in the angular version of returnsButton
  returnsHelpTooltip.name,
]);
